import * as Factory from 'factory.ts'
import faker from 'faker'

import { PayCardTypes } from '@webapp/models/enums'
import { type StripeCard } from '@webapp/models/StripeCard'
import { PayCardholderMock } from './payCardholder.factory'
import { PayCardStatuses } from '../../models/enums/PayCardStatus'
import {
  type PayCard,
  type PayCardCustomShippingAddress,
  type SimplePayCard,
} from '../../models/PayCard'

export const SimplePayCardMock = Factory.Sync.makeFactory<SimplePayCard>({
  id: Factory.each(() => faker.random.number()),
  external_id: `ic_${faker.random.alphaNumeric(24)}`,
  name: faker.random.word(),
  number: Factory.each(() =>
    faker.random.number({ min: 1000, max: 9999 }).toString()
  ),
  status: PayCardStatuses.ACTIVE,
  created_at: faker.date.past(10).toISOString(),
  require_activation: false,
})

export const PayCardMock = Factory.Sync.makeFactory<PayCard>({
  id: Factory.each(() => faker.random.number()),
  external_id: `ic_${faker.random.alphaNumeric(24)}`,
  name: faker.random.word(),
  number: Factory.each(() =>
    faker.random.number({ min: 1000, max: 9999 }).toString()
  ),
  status: PayCardStatuses.ACTIVE,
  created_at: faker.date.past(10).toISOString(),
  require_activation: faker.random.boolean(),
  balance: Factory.each(() => faker.finance.amount()),
  cardholder: Factory.each(() => PayCardholderMock.build()),
  updated_at: faker.date.past(20).toISOString(),
  category: PayCardTypes.PHYSICAL,
})

export const PayCardAddressMock =
  Factory.Sync.makeFactory<PayCardCustomShippingAddress>({
    name: Factory.each(() => faker.random.words(3)),
    address_line_one: Factory.each(() => faker.address.streetAddress()),
    address_line_two: 'Unit 100',
    city: Factory.each(() => faker.address.city()),
    postal_code: Factory.each(() => faker.address.zipCode()),
    state_province: Factory.each(() => faker.address.state()),
    country: Factory.each(() => faker.address.country()),
  })

// This is derived from Stripe's API: https://stripe.com/docs/api/issuing/cards/object
export const StripeCardMock = Factory.Sync.makeFactory<StripeCard>({
  id: `ic_${faker.random.alphaNumeric(24)}`,
  object: 'issuing.card',
  brand: 'Visa',
  cancellation_reason: null,
  cardholder: {
    id: `ich_${faker.random.alphaNumeric(24)}`,
    object: 'issuing.cardholder',
    billing: {
      address: {
        city: faker.address.city(),
        country: faker.address.country(),
        line1: faker.address.streetAddress(),
        line2: 'Apt 3',
        postal_code: faker.address.zipCode(),
        state: faker.address.state(),
      },
    },
    company: null,
    created: 1528992903,
    email: 'jenny@example.com',
    individual: null,
    livemode: false,
    metadata: {},
    name: 'Jenny Rosen',
    phone_number: '+18008675309',
    requirements: {
      disabled_reason: null,
      past_due: [],
    },
    spending_controls: {
      allowed_categories: [],
      blocked_categories: [],
      spending_limits: [],
      spending_limits_currency: null,
    },
    status: 'active',
    type: 'individual',
  },
  created: 1567541772,
  currency: 'usd',
  exp_month: 12,
  exp_year: 2020,
  last4: '4242',
  livemode: false,
  metadata: null,
  replaced_by: null,
  replacement_for: null,
  replacement_reason: null,
  shipping: null,
  spending_controls: {
    allowed_categories: null,
    blocked_categories: null,
    spending_limits: [],
    spending_limits_currency: null,
  },
  status: 'active',
  type: 'virtual',
  cvc: 789,
  number: 4242424242424242,
})
